export default __webpack_public_path__ + "static/media/1.479072e2.jpg";